var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAssemblyCountByAIMNum } from '../../services/AssemblyService';
import { configure } from '../../services/ConfigitService';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { SearchBox } from '../shared/SearchBox';
import { ErrorModalComponent } from '../shared/ErrorModalComponent/ErrorModalComponent';
import { Dialog } from '../shared/DialogComponent/Dialog';
import { jsx as _jsx } from "react/jsx-runtime";
export var AIMNumberSearch = function () {
    var navigate = useNavigate();
    var location = useLocation();
    var params = new URLSearchParams(location.search);
    var _a = useContext(ApplicationContext), setDialog = _a.setDialog, setShowDialog = _a.setShowDialog, setLoading = _a.setLoading, setSearchAIMNum = _a.setSearchAIMNum, setItemOffset = _a.setItemOffset, setItemsPerPage = _a.setItemsPerPage, setFilters = _a.setFilters;
    var _b = useContext(ConfigitContext), variableAssignments = _b.variableAssignments, setVariableAssignments = _b.setVariableAssignments, layers = _b.layers, setLayers = _b.setLayers, excludedLayerIds = _b.excludedLayerIds, setExcludedLayerIds = _b.setExcludedLayerIds, setSections = _b.setSections;
    var _c = useState(''), value = _c[0], setValue = _c[1];
    var _d = useState(''), errMsg = _d[0], setErrMsg = _d[1];
    var _e = useContext(ApplicationContext), triggerSearchResultCount = _e.triggerSearchResultCount, setTriggerSearchResultCount = _e.setTriggerSearchResultCount;
    var _f = useContext(ApplicationContext), triggerRoofTypeList = _f.triggerRoofTypeList, setTriggerRoofTypeList = _f.setTriggerRoofTypeList;
    var _g = useContext(ApplicationContext), triggerAssemblyList = _g.triggerAssemblyList, setTriggerAssemblyList = _g.setTriggerAssemblyList;
    var _h = useContext(ApplicationContext), numShowResult = _h.numShowResult, setNumShowResult = _h.setNumShowResult;
    var _j = useContext(ApplicationContext), autoRefreshSearchResult = _j.autoRefreshSearchResult, setAutoRefreshSearchResult = _j.setAutoRefreshSearchResult;
    var search = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var filters_1, count, freshSections_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(value === '')) return [3 /*break*/, 1];
                    setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, { message: "Please enter an AIM number for search." }) }));
                    setShowDialog(true);
                    return [3 /*break*/, 5];
                case 1:
                    setLoading(true);
                    filters_1 = { NavAssemblyName: { _eq: "AIM_".concat(value) } };
                    return [4 /*yield*/, getAssemblyCountByAIMNum(value)];
                case 2:
                    count = _a.sent();
                    setLoading(false);
                    if (!(count && count > 0)) return [3 /*break*/, 4];
                    setSearchAIMNum(value);
                    setItemOffset(0);
                    setItemsPerPage(25);
                    setErrMsg('');
                    setValue(''); // Fetch fresh default sections so Assembly Properties panel resets cleanly,
                    return [4 /*yield*/, configure([])];
                case 3:
                    freshSections_1 = _a.sent();
                    unstable_batchedUpdates(function () { setSections(freshSections_1); if (variableAssignments.length)
                        setVariableAssignments([]); if (layers.some(function (layer) { return !layer.autoSelected; }))
                        setLayers([]); if (excludedLayerIds.length)
                        setExcludedLayerIds([]); setFilters(filters_1); });
                    if (!autoRefreshSearchResult) {
                        setTriggerSearchResultCount(true);
                        setTriggerRoofTypeList(true);
                        setTriggerAssemblyList(true);
                        setNumShowResult(numShowResult + 1);
                    }
                    navigate("assembliesListing?".concat(params.toString()));
                    return [3 /*break*/, 5];
                case 4:
                    setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, { message: "Your search criteria returned no results." }) }));
                    setShowDialog(true);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ _jsx(SearchBox, { label: "Enter AIM #", value: value, setValue: setValue, search: search, restrictKeyPress: /^[a-zA-Z0-9\b]+$/, errMsg: errMsg });
};
export var AIMNumber = function () { return /*#__PURE__*/ _jsx(AIMNumberSearch, {}); };
